"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pricing = require("../helpers/pricing");
var ExtrasTransferBreakdown = function ExtrasTransferBreakdown(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/_react["default"].createElement("p", null, "".concat(variant.description || variant.product.description, " - ").concat((0, _pricing.formatCurrency)(variant.price / 100, variant.currency)));
};
ExtrasTransferBreakdown.propTypes = {
  variant: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ExtrasTransferBreakdown;